import { Component } from '@angular/core';
import { IconV3Component } from '@gea/digital-ui-lib';

import { ChangeDetectionStrategy } from '@angular/core';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'gea-hrt-hint',
  standalone: true,
  imports: [IconV3Component],
  template: `
    <span class="gea-hrt-hint-icon-container">
      <geaui-icon-v3 file="exclamation-mark" [fileSize]="16" color="gray" containerColor="active-blue" />
    </span>
    <span class="gea-hrt-hint-text-container">
      <div>
        <ng-content></ng-content>
      </div>
    </span>
  `,

  styles: `
    .gea-hrt-hint-icon-container {
      float: left;
      ::ng-deep {
        svg,
        path {
          stroke: unset !important;
        }
      }
    }
    .gea-hrt-hint-text-container {
      float: left;
      line-height: 26px;
      margin-left: 10px;
    }
  `,
})
export class HintComponent {}
